import { supabase } from "@/lib/supabase";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

async function platformRequest(path, options = {}) {
  const { data, error } = await supabase.auth.getSession();
  if (error || !data?.session?.access_token) {
    throw new Error("Sign in again to continue.");
  }

  const response = await fetch(`${API_BASE}/api/platform${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${data.session.access_token}`,
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    let detail = "";
    try {
      const raw = await response.text();
      try {
        detail = JSON.parse(raw).detail || raw;
      } catch {
        detail = raw;
      }
    } catch {
      detail = "";
    }
    const requestError = new Error(detail || `Request failed (${response.status})`);
    requestError.status = response.status;
    throw requestError;
  }

  if (response.status === 204) return null;
  return response.json();
}

export function bootstrapPlatformOwner(token) {
  return platformRequest("/bootstrap", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
}

export function listPlatformCenters() {
  return platformRequest("/centers");
}

export function createPlatformCenter(payload) {
  return platformRequest("/centers", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function listCenterAdministrators(organizationId) {
  return platformRequest(`/centers/${organizationId}/administrators`);
}

export function assignCenterAdministrator(organizationId, payload) {
  return platformRequest(`/centers/${organizationId}/administrators`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function listPlatformAudit() {
  return platformRequest("/audit");
}
